import moment from "moment";

const parser = require("ua-parser-js");
import { interval } from "rxjs";
import { ajax } from "rxjs/ajax";
import { delay, first, mergeMap, filter, retry } from "rxjs/operators";
import version from "./version";
import auth from "../store/modules/auth";
import { toObject } from "./languageContent";

export const baseUrl = () => {
    if (document.currentScript) {
        let _documentUrl = document.currentScript.src.split("/");
        return _documentUrl[0] + "//" + _documentUrl[2] + "/";
    } else {
        return "/";
    }
};
/**
 *
 * @param key string veya value üreten bir fonksiyon olabilir
 * @param type alabilceği değerler= string(default) || number|| date
 * @param sortedInfo object {columnKey:String,order:(ascend|descend)} şuanki tablodaki sıralama bilgisi
 * @param keyName keyi eğer FN olarak verdiyseniz sıralama kıyaslancak key'i buraya giriniz.
 * @returns {{defaultSortOrder: string, sorter: (function(*=, *=): number)}}
 */
export const tableSorter = (key, type = "string", sortedInfo, keyName) => {
    const result = {
        sortOrder: sortedInfo
            ? sortedInfo.columnKey === (typeof key === "function" ? keyName : key) && sortedInfo.order
            : undefined,

        sorter: (a, b) => {
            const keyIsFunction = typeof key === "function";
            if (keyIsFunction) {
                a = key(a);
                b = key(b);
            } else {
                if (type === "number") {
                    a = _.get(a, key);
                    b = _.get(b, key);
                } else if (type === "array_len") {
                    a = Array.isArray(_.get(a, key)) ? _.get(a, key).length : 0;
                    b = Array.isArray(_.get(b, key)) ? _.get(b, key).length : 0;
                } else if (type === "date") {
                    a =
                        _.get(a, key) && moment(_.get(a, key)).toDate().getTime()
                            ? moment(_.get(a, key)).toDate().getTime()
                            : null;
                    b =
                        _.get(b, key) && moment(_.get(b, key)).toDate().getTime()
                            ? moment(_.get(b, key)).toDate().getTime()
                            : null;
                } else {
                    a = _.get(a, key) ? _.get(a, key).toString().trim().toLowerCase() : _.get(a, key);
                    b = _.get(b, key) ? _.get(b, key).toString().trim().toLowerCase() : _.get(b, key);
                }
            }
            return _.sortBy([a, b])[0] === a ? 1 : -1;
        },
    };
    if (!result.sortOrder) delete result.sortOrder;
    return result;
};

export const agentOS = parser(navigator.userAgent).os.name;
export const isMac = agentOS === "Mac OS";

const versionInfoRequest = () => ajax.getJSON(location.origin + "/static/version.json").pipe(delay(1000));

export const onNewVersionReceived = interval(60 * 1000)
    .pipe(
        mergeMap((_) => versionInfoRequest()),
        retry(),
        filter((remoteVersion) => version.versionStr !== remoteVersion.version),
        first()
    )
    .toPromise();

export const PRODUCTION = process.env.PRODUCTION === "true";
export const IS_DEV_ENVIRONMENT = process.env.ENVIRONMENT === "development";
export const IS_STAGE_ENVIRONMENT = process.env.ENVIRONMENT === "stage";
export const IS_PROD_ENVIRONMENT = process.env.ENVIRONMENT === "production";

export const SELF_SERVICE_DOMAIN = IS_DEV_ENVIRONMENT
    ? "local.supsis.live"
    : IS_STAGE_ENVIRONMENT
    ? "beta.supsis.live"
    : "supsis.live";

export const fakeConversation = () => ({
    active: true,
    chatBarOrder: 1,
    connectedDate: new Date().toISOString(),
    connectedUser: "5fc8af6effdadb0020624905",
    createdDate: new Date().toISOString(),
    email: "tanitim@supsis.com",
    fullname: "Supsis Tanıtım",
    username: "supsisTanitim",
    users: [auth.state.user],
    visitor: {
        browser: "Chrome 87.0.4280 ",
        country: "N/A",
        ipAddress: "172.18.0.1",
        os: " Mac OS X 11.1.0",
        _id: "5fc8af6effdadb0020624905",
    },
    messages: [
        {
            conversation: "5fc8af6effdadb0020624905",
            createdDate: "2020-12-25T13:13:49.090Z",
            description: "Aramıza hoşgeldiniz",
            messageType: "system",
            systemMessageType: "welcome-message",
            updatedBy: null,
            __v: 0,
            _id: "5fc8af6effdadb0020624905",
        },
    ],
    isOnline: true,
    unread: 0,
    languageCode: "tr",
});

export const fakeContents = () =>
    [
        {
            _id: "5d33901fd4357c001deb2511",
            updatedAt: "2019-07-20T22:07:50.405Z",
            createdAt: "2019-07-20T22:05:19.580Z",
            isActive: true,
            number: "0",
            name: "ödeme",
            letter: "test 123",
            content: "test 123",
            __v: 0,
            isDeleted: false,
            updatedBy: null,
            createdBy: null,
            type: "TITLE",
            languageContent: [
                { name: "ödeme", content: "test 123", languageCode: "tr" },
                {
                    name: "paymenty",
                    content: "test 123",
                    languageCode: "en",
                },
            ],
            parentId: null,
        },
        {
            _id: "5fc8b31e10d1980019dceb7a",
            updatedAt: "2020-12-03T09:42:54.595Z",
            createdAt: "2020-12-03T09:42:54.595Z",
            letter: "sip",
            number: "s",
            isActive: true,
            isDeleted: false,
            updatedBy: null,
            createdBy: { _id: "5fc8af6effdadb0020624902" },
            type: "TAB",
            languageContent: [
                {
                    name: "sipariş no",
                    content: "sipariş numaranız nedir",
                    languageCode: "tr",
                },
                {
                    name: "order no",
                    content: "order no yazın",
                    languageCode: "en",
                },
            ],
            parentId: "5d33901fd4357c001deb2511",
            __v: 0,
        },
        {
            _id: "5fc8b31e10d1980019dceb7b",
            updatedAt: "2020-12-03T09:42:54.595Z",
            createdAt: "2020-12-03T09:42:54.595Z",
            letter: "m",
            number: "",
            isActive: true,
            isDeleted: false,
            updatedBy: null,
            createdBy: { _id: "5fc8af6effdadb0020624902" },
            type: "ALT",
            languageContent: [
                {
                    name: "sipariş no",
                    content: "sipariş numaranız nedir",
                    languageCode: "tr",
                },
                {
                    name: "order no",
                    content: "order no yazın",
                    languageCode: "en",
                },
            ],
            parentId: "5d33901fd4357c001deb2511",
            __v: 0,
        },
    ].map((x) => toObject(x));

export const capitalize = (str = "") => {
    str = str.trim().toLowerCase();
    return str
        .split(" ")
        .map((x) => x.trim())
        .filter((x) => x.length > 0)
        .map((x) => `${x[0].toUpperCase()}${x.substring(1)}`)
        .map((x) => x.trim())
        .join(" ");
};

export const validateEmail = (email) => {
    console.log("validateEmail", email);
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

export const WHATSAPP_COMMANDS = {
    GET_CONTACTS: `whatsapp get-contacts`,
};
